"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util = require("node:util");
exports.default = (obj) => util.types.isKeyObject(obj);
